// extracted by mini-css-extract-plugin
module.exports = {"root":"_1sSkXBo","cta":"_6wcQidI","icon":"_3rrWllt","loader":"_2OQqdiR"};
    if(module.hot) {
      // 1545369437587
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  